import React, {
    useState,
    useEffect
} from "react";

import {
    FontAwesomeIcon
} from "@fortawesome/react-fontawesome";


export default function UtilisationSummaryRow({
    index,
    icon,
    title,
    values,
    componentHeight
})
{

    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [ready, setReady] =
        useState(false);


    //--------------------------------------------------------
    // Entrance animation
    //--------------------------------------------------------

    useEffect(
        function()
        {

            const timer =
                setTimeout(
                    function()
                    {
                        setReady(
                            true
                        );
                    },
                    index * 150
                );


            return function()
            {
                clearTimeout(
                    timer
                );
            };

        },
        [index]
    );


    //--------------------------------------------------------
    // Format value
    //--------------------------------------------------------

    function formatValue(val)
    {

        if(
            val === null
            ||
            val === undefined
        )
        {
            return "—";
        }


        /*
         * Handle strings such as NaN or NaN%
         */

        if(typeof val === "string")
        {

            if(val.includes("NaN"))
            {
                return "—";
            }

            return val;
        }


        /*
         * Handle actual NaN numbers
         */

        if(
            typeof val === "number"
            &&
            isNaN(val)
        )
        {
            return "—";
        }


        return val;

    }


    //========================================================
    // Styles
    //========================================================


    //--------------------------------------------------------
    // Complete row
    //--------------------------------------------------------

    const contentRow =
    {
        display:
            "flex",

        width:
            "calc(100% - 80px)",

        marginTop:
            "20px",

        marginLeft:
            "40px",

        /*
         * Structural element = square.
         */

        borderRadius:
            "0px",

        overflow:
            "hidden",

        background:
            "#ffffff",

        border:
            "1px solid rgba(7,28,49,0.08)",

        boxShadow:
            "0 8px 20px rgba(7,28,49,0.10), " +
            "0 2px 5px rgba(7,28,49,0.06)",

        /*
         * Existing staggered entrance.
         */

        opacity:
            ready
                ? 1
                : 0,

        transform:
            ready
                ? "translateY(0px)"
                : "translateY(20px)",

        transition:
            "opacity 0.5s ease, transform 0.5s ease"
    };


    //--------------------------------------------------------
    // Left title panel
    //--------------------------------------------------------

    const contentBox =
    {
        position:
            "relative",

        display:
            "flex",

        height:
            "100%",

        minHeight:
            componentHeight + "px",

        alignItems:
            "center",

        width:
            "270px",

        minWidth:
            "270px",

        overflow:
            "hidden",

        background:
            "#0c3558",

        borderRight:
            "1px solid rgba(141,200,240,0.18)"
    };


    //--------------------------------------------------------
    // Watermark icon
    //--------------------------------------------------------

    const headerIcon =
    {
        position:
            "absolute",

        left:
            "-8px",

        bottom:
            "-18px",

        width:
            "88px",

        height:
            "88px",

        color:
            "rgba(141,200,240,0.14)",

        pointerEvents:
            "none",

        zIndex:
            1
    };


    //--------------------------------------------------------
    // Title
    //--------------------------------------------------------

    const headerTitle =
    {
        position:
            "relative",

        zIndex:
            2,

        display:
            "flex",

        alignItems:
            "center",

        color:
            "#ffffff",

        fontSize:
            "16px",

        fontWeight:
            500,

        lineHeight:
            "19px",

        /*
         * Leave enough room for the watermark.
         */

        marginLeft:
            "82px",

        paddingRight:
            "18px"
    };


    //--------------------------------------------------------
    // Figures area
    //--------------------------------------------------------

    const contentFigureContainerHighlight =
    {
        display:
            "flex",

        flex:
            1,

        height:
            (componentHeight + 4) + "px",

        alignItems:
            "center",

        background:
            "linear-gradient(" +
                "180deg," +
                "#ffffff 0%," +
                "#f5f7fa 100%" +
            ")"
    };


    //--------------------------------------------------------
    // Individual figure
    //--------------------------------------------------------

    const contentFigure =
    {
        display:
            "flex",

        flex:
            1,

        height:
            "100%",

        alignItems:
            "center",

        justifyContent:
            "center",

        boxSizing:
            "border-box",

        fontSize:
            "21px",

        fontWeight:
            400,

        color:
            "#343a40",

        /*
         * Gives us subtle five-column structure.
         */

        borderRight:
            "1px solid rgba(7,28,49,0.06)"
    };


    //========================================================
    // Render
    //========================================================

    return (

        <div style={contentRow}>


            {/* ================================================
                ROW TITLE
            ================================================= */}

            <div style={contentBox}>

                <FontAwesomeIcon
                    icon={
                        icon
                    }

                    style={
                        headerIcon
                    }
                />


                <div
                    style={
                        headerTitle
                    }
                >

                    {title}

                </div>

            </div>


            {/* ================================================
                FIGURES
            ================================================= */}

            <div
                style={
                    contentFigureContainerHighlight
                }
            >

                {
                    values.map(
                        function(val, i)
                        {

                            return (

                                <div
                                    key={
                                        i
                                    }

                                    style={{
                                        ...contentFigure,

                                        borderRight:
                                            i === values.length - 1
                                                ?
                                                "none"
                                                :
                                                contentFigure.borderRight
                                    }}
                                >

                                    {formatValue(val)}

                                </div>

                            );

                        }
                    )
                }

            </div>

        </div>

    );

}